module.exports = {
  DEFAULT: "0px 0px 16px rgba(28, 24, 49, 0.16)",
};
